// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  function $parcel$resolve(url) {  url = importMap[url] || url;  return new URL(distDir + url, import.meta.url).toString();}newRequire.resolve = $parcel$resolve;function $parcel$extendImportMap(map) {  Object.assign(importMap, map);}newRequire.extendImportMap = $parcel$extendImportMap;

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"2Iv0m":[function(require,module,exports,__globalThis) {
module.bundle.extendImportMap({
    "eLRmK": "wheelchair.48b0c155.svg",
    "jWxbY": "wheelchair-inaccessible.d8728d37.svg",
    "aNzh1": "bus-single.a4b4959f.svg",
    "iEMtA": "bus-double.cac6d2e8.svg",
    "23O3W": "bus-bendy.d4297a2a.svg"
});

},{}],"irHKn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _i18N = require("./i18n");
var _errorTracking = require("./error-tracking");
var _preact = require("preact");
var _hooks = require("preact/hooks");
var _reactI18Next = require("react-i18next");
var _bus = require("./utils/bus");
var _fetchCache = require("./utils/fetchCache");
var _fetchCacheDefault = parcelHelpers.interopDefault(_fetchCache);
var _setIcon = require("../utils/setIcon");
var _setIconDefault = parcelHelpers.interopDefault(_setIcon);
var _arrivalTimeText = require("./components/ArrivalTimeText");
var _arrivalTimeTextDefault = parcelHelpers.interopDefault(_arrivalTimeText);
var _localeSelector = require("./components/LocaleSelector");
var _localeSelectorDefault = parcelHelpers.interopDefault(_localeSelector);
var _wheelchairSvg = require("./images/wheelchair.svg");
var _wheelchairSvgDefault = parcelHelpers.interopDefault(_wheelchairSvg);
var _wheelchairInaccessibleSvg = require("./images/wheelchair-inaccessible.svg");
var _wheelchairInaccessibleSvgDefault = parcelHelpers.interopDefault(_wheelchairInaccessibleSvg);
var _busSingleSvg = require("./images/bus-single.svg");
var _busSingleSvgDefault = parcelHelpers.interopDefault(_busSingleSvg);
var _busDoubleSvg = require("./images/bus-double.svg");
var _busDoubleSvgDefault = parcelHelpers.interopDefault(_busDoubleSvg);
var _busBendySvg = require("./images/bus-bendy.svg");
var _busBendySvgDefault = parcelHelpers.interopDefault(_busBendySvg);
const dataPath = 'https://data.busrouter.sg/v1/';
const stopsJSONPath = dataPath + 'stops.min.json';
const BUSES = {
    sd: {
        alt: 'Single deck bus',
        src: (0, _busSingleSvgDefault.default),
        width: 20
    },
    dd: {
        alt: 'Double deck bus',
        src: (0, _busDoubleSvgDefault.default),
        width: 20
    },
    bd: {
        alt: 'Bendy bus',
        src: (0, _busBendySvgDefault.default),
        width: 26
    }
};
const WheelChair = ({ size = 11 })=>(0, _preact.h)("img", {
        src: (0, _wheelchairSvgDefault.default),
        width: size,
        height: size,
        alt: "Wheelchair accessible"
    });
const WheelChairInaccessible = ({ size = 11 })=>(0, _preact.h)("img", {
        src: (0, _wheelchairInaccessibleSvgDefault.default),
        width: size,
        height: size,
        alt: "Wheelchair inaccessible"
    });
const Bus = (props)=>{
    const { maxPx, index, duration_ms, type, load, feature, _ghost, _id } = props;
    const busImage = BUSES[type.toLowerCase()];
    const prevPx = (0, _hooks.useRef)();
    const px = duration_ms / 1000 / 60 * (duration_ms > 0 ? 10 : 2.5);
    const busTooFar = px > maxPx - 30; // 30 = bus width
    const pxFar = 90 + index * 2; // index = zero-based
    (0, _hooks.useEffect)(()=>{
        prevPx.current = px;
    }, [
        px
    ]);
    let time = 1; // 1 second
    if (prevPx.current) {
        const distance = Math.abs(prevPx.current - px);
        time = distance / 10;
    }
    return (0, _preact.h)("span", {
        id: _id ? `bus-${_id}` : null,
        class: `bus ${_ghost ? 'ghost' : ''}`,
        style: {
            marginLeft: busTooFar ? pxFar + '%' : px.toFixed(1) + 'px',
            transitionDuration: `${time}s`
        }
    }, (0, _preact.h)("span", {
        class: "bus-float"
    }, (0, _preact.h)("img", busImage), (0, _preact.h)("br", null), (0, _preact.h)("span", {
        class: `time time-${load.toLowerCase()}`
    }, (0, _preact.h)((0, _arrivalTimeTextDefault.default), {
        ms: duration_ms
    })), feature.toLowerCase() !== 'wab' && (0, _preact.h)(WheelChairInaccessible, null)));
};
let BUSID = 1;
const busID = ()=>BUSID++;
const isSameBus = (b1, b2)=>b1.feature === b2.feature && b1.type === b2.type && b1.visit_number === b2.visit_number && b1.origin_code === b2.origin_code && b1.destination_code === b2.destination_code;
const isSameBuses = (b1, b2)=>b1.map((b)=>b._id).join() === b2.map((b)=>b._id).join();
function BusLane({ index, no, buses }) {
    const prevNo = (0, _hooks.useRef)();
    const prevBuses = (0, _hooks.useRef)();
    const nextBuses = buses.filter((nb)=>typeof nb?.duration_ms === 'number');
    if (prevNo.current === no && !isSameBuses(prevBuses.current, nextBuses)) {
        nextBuses.forEach((nb)=>{
            delete nb._id;
        });
        const pBuses = prevBuses.current.filter((b)=>!b._ghost); // Remove previously ghosted buses
        pBuses.forEach((b, i)=>{
            // Next bus requirements/checks
            // - Within range of duration_ms of current bus
            // - Not assigned with ID (possibly from previous loop execution)
            // - Same bus type as current bus
            const latestNextBus = nextBuses.find((nb)=>{
                if (nb._id || !isSameBus(b, nb)) return false;
                const d = (nb.duration_ms - b.duration_ms) / 1000 / 60;
                return d > -5 && d < 3;
            });
            if (latestNextBus) latestNextBus._id = b._id; // Assign ID for marking
            else {
                // Insert "ghost" bus that will dissapear into thin air
                b._ghost = true;
                nextBuses.splice(i, 0, b);
            }
        });
    }
    nextBuses.forEach((nb)=>{
        if (!nb._id) nb._id = busID();
    });
    // DEBUGGING
    // const prevBusesClone = structuredClone(prevBuses.current);
    // const nextBusesClone = structuredClone(nextBuses);
    // if (no == 315) {
    //   console.log(
    //     no,
    //     prevBusesClone?.map((b) => b._id)?.join(),
    //     nextBusesClone?.map((b) => b._id)?.join(),
    //   );
    // }
    (0, _hooks.useEffect)(()=>{
        prevNo.current = no;
        prevBuses.current = structuredClone(nextBuses);
    }, [
        no,
        nextBuses
    ]);
    const busLaneRef = (0, _hooks.useRef)();
    const [busLaneWidth, setBusLaneWidth] = (0, _hooks.useState)(0);
    (0, _hooks.useLayoutEffect)(()=>{
        setBusLaneWidth(busLaneRef.current?.offsetWidth);
    }, []);
    return (0, _preact.h)("div", {
        class: "bus-lane",
        ref: busLaneRef
    }, nextBuses.map((b, i)=>(0, _preact.h)(Bus, (0, _extendsDefault.default)({
            key: b._id,
            index: i
        }, b, {
            maxPx: busLaneWidth
        }))), index && (0, _preact.h)("span", {
        class: "visit-number"
    }, index));
}
function ArrivalTimes() {
    const { t, i18n } = (0, _reactI18Next.useTranslation)();
    const [busStop, setBusStop] = (0, _hooks.useState)(null);
    const [stopsData, setStopsData] = (0, _hooks.useState)(null);
    const [fetchServicesStatus, setFetchServicesStatus] = (0, _hooks.useState)(null); // 'loading', 'error', 'online'
    const [services, setServices] = (0, _hooks.useState)(null);
    const initialPinnedServices = JSON.parse(localStorage.getItem('busroutersg.arrival.pinnedServices')) || [];
    const [pinnedServices, setPinnedServices] = (0, _hooks.useState)(initialPinnedServices);
    (0, _hooks.useEffect)(async ()=>{
        const stops = await (0, _fetchCacheDefault.default)(stopsJSONPath, 1440);
        window.onhashchange = ()=>{
            const code = location.hash.slice(1);
            if (code) {
                const stop = stops[code];
                if (stop) {
                    const [lng, lat, name] = stop;
                    setBusStop({
                        code,
                        name,
                        lat,
                        lng
                    });
                    (0, _setIconDefault.default)(code);
                } else alert(t('arrivals.invalidBusStopCode'));
            } else setBusStop(null);
        };
        window.onhashchange();
        setStopsData(stops);
    }, []);
    (0, _hooks.useEffect)(()=>{
        if (busStop?.code) {
            const { code, name } = busStop;
            document.title = t('arrivals.titleStop', {
                stopNumber: code,
                stopName: name
            });
            document.querySelector('[name="apple-mobile-web-app-title"]').setAttribute('content', document.title);
        } else {
            document.title = t('arrivals.title');
            document.querySelector('[name="apple-mobile-web-app-title"]').setAttribute('content', document.title);
        }
    }, [
        busStop,
        i18n.resolvedLanguage
    ]);
    let arrivalsTimeout, arrivalsRAF;
    function fetchServices(id) {
        if (!id) return;
        if (window._PAUSED) return;
        setFetchServicesStatus('loading');
        fetch(`https://arrivelah2.busrouter.sg/?id=${id}`).then((r)=>r.json()).then((results)=>{
            setFetchServicesStatus(results.services?.length ? 'online' : null);
            setServices(results.services);
            arrivalsTimeout = setTimeout(()=>{
                arrivalsRAF = requestAnimationFrame(()=>fetchServices(id));
            }, 15000); // 15 seconds
        }).catch((e)=>{
            setFetchServicesStatus('error');
            arrivalsTimeout = setTimeout(()=>{
                arrivalsRAF = requestAnimationFrame(()=>fetchServices(id));
            }, 3000); // 3 seconds
        });
    }
    (0, _hooks.useEffect)(()=>{
        if (busStop) fetchServices(busStop.code);
        return ()=>{
            clearTimeout(arrivalsTimeout);
            cancelAnimationFrame(arrivalsRAF);
        };
    }, [
        busStop
    ]);
    function togglePin(no) {
        if (pinnedServices.includes(no)) {
            const index = pinnedServices.indexOf(no);
            pinnedServices.splice(index, 1);
        } else pinnedServices.push(no);
        setPinnedServices([
            ...pinnedServices
        ]);
        try {
            localStorage.setItem('busroutersg.arrival.pinnedServices', JSON.stringify(pinnedServices));
        } catch (e) {}
    }
    if (!busStop) {
        if (stopsData) return (0, _preact.h)("ul", {
            class: "stops-list"
        }, Object.keys(stopsData).map((stop)=>(0, _preact.h)("li", null, (0, _preact.h)("a", {
                href: `#${stop}`
            }, stopsData[stop][2]))));
        return;
    }
    const { code, name, lat, lng } = busStop;
    if (services) services.sort((0, _bus.sortServicesPinned)(pinnedServices));
    const hasMultipleVisits = services?.some((service)=>{
        const { next, next2, next3 } = service;
        return next?.visit_number > 1 || next2?.visit_number > 1 || next3?.visit_number > 1;
    });
    return (0, _preact.h)("div", null, (0, _preact.h)("div", {
        id: "bus-stop-map"
    }, (0, _preact.h)("img", {
        src: `https://busroutersg-staticmaps.cheeaun.workers.dev/${lng},${lat},17,0,60/400x200@2x`,
        alt: "Bus stop map",
        width: "400",
        height: "200",
        intrinsicsize: "400x200",
        loading: "lazy"
    })), (0, _preact.h)("h1", null, t('arrivals.preHeading'), (0, _preact.h)("b", {
        id: "bus-stop-name"
    }, (0, _preact.h)("span", {
        class: `stop-tag ${fetchServicesStatus}`
    }, code), " ", name)), (0, _preact.h)("table", null, services ? services.length ? (0, _preact.h)("tbody", {
        class: !services.length ? 'loading' : ''
    }, services.map(({ no, next, next2, next3 })=>{
        const pinned = pinnedServices.includes(no);
        const buses = [
            next,
            next2,
            next3
        ];
        const buses1 = buses.filter((b)=>b?.visit_number === 1);
        const buses2 = buses.filter((b)=>b?.visit_number === 2);
        return (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)("tr", {
            class: pinned ? 'pin' : ''
        }, (0, _preact.h)("th", {
            onClick: (e)=>{
                e.preventDefault();
                togglePin(no);
            }
        }, no), (0, _preact.h)("td", {
            class: `bus-lane-cell ${buses2.length ? 'multiple' : ''}`
        }, buses2.length ? (0, _preact.h)((0, _preact.Fragment), null, (0, _preact.h)(BusLane, {
            index: 1,
            no: no,
            buses: buses1
        }), (0, _preact.h)(BusLane, {
            index: 2,
            no: no,
            buses: buses2
        })) : (0, _preact.h)(BusLane, {
            no: no,
            buses: buses
        }))), (0, _preact.h)("tr", {
            class: pinned ? 'pin' : ''
        }, (0, _preact.h)("th", {
            colspan: "2"
        }, (0, _preact.h)("small", {
            class: "destination"
        }, next?.destination_code && stopsData[next.destination_code]?.[2] || next?.destination_code || ''))));
    })) : (0, _preact.h)("tbody", null, (0, _preact.h)("tr", null, (0, _preact.h)("td", {
        class: "blank"
    }, "No arrival times available."))) : (0, _preact.h)("tbody", {
        class: "loading"
    }, (0, _preact.h)("tr", null, (0, _preact.h)("td", null, "Loading\u2026")))), (0, _preact.h)("div", {
        class: "legend"
    }, (0, _preact.h)("div", {
        class: "loads"
    }, (0, _preact.h)("span", {
        class: "load load-sea"
    }, t('glossary.seatsAvailable')), (0, _preact.h)("span", {
        class: "load load-sda"
    }, t('glossary.standingAvailable')), (0, _preact.h)("span", {
        class: "load load-lsd"
    }, t('glossary.limitedStanding'))), hasMultipleVisits && (0, _preact.h)("p", {
        class: "visits"
    }, (0, _preact.h)("span", {
        class: "visit-numbers"
    }, (0, _preact.h)("span", {
        class: "visit-number"
    }, "1"), (0, _preact.h)("span", {
        class: "visit-number"
    }, "2")), t('arrivals.multipleVisitsLegend'))), (0, _preact.h)("footer", null, (0, _preact.h)((0, _reactI18Next.Trans), {
        i18nKey: "arrivals.wheelchairDisclaimer"
    }, (0, _preact.h)(WheelChair, {
        size: "16"
    }), " All public buses in revenue service are", (0, _preact.h)("a", {
        href: "https://en.wikipedia.org/wiki/Public_buses_of_Singapore#2020s:_In_with_electric_buses,_out_with_non-wheelchair-accessible_buses",
        target: "_blank"
    }, "wheelchair-accessible"), ". The ones that are not accesssible will be marked with this icon", (0, _preact.h)(WheelChairInaccessible, {
        size: "16"
    }), "."), (0, _preact.h)("p", null, (0, _preact.h)((0, _localeSelectorDefault.default), null))));
}
const $arrivals = document.getElementById('arrivals');
(0, _preact.render)((0, _preact.h)(ArrivalTimes, null), $arrivals);

},{"@babel/runtime/helpers/esm/extends":"5DN8g","./i18n":"h6hrD","./error-tracking":"PbMFz","preact":"fvkQC","preact/hooks":"2EbRR","react-i18next":"3s9bS","./utils/bus":"4E495","./utils/fetchCache":"kNdlE","../utils/setIcon":"kYMHw","./components/ArrivalTimeText":"7XWv2","./components/LocaleSelector":"jTEXS","./images/wheelchair.svg":"l7Ehb","./images/wheelchair-inaccessible.svg":"jzyZP","./images/bus-single.svg":"knC2F","./images/bus-double.svg":"4C2c8","./images/bus-bendy.svg":"m2QM4","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"5DN8g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"ftQX7":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"4E495":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "timeDisplay", ()=>timeDisplay);
parcelHelpers.export(exports, "sortServices", ()=>sortServices);
parcelHelpers.export(exports, "sortServicesPinned", ()=>sortServicesPinned);
const timeDisplay = (ms)=>{
    if (ms === null) return;
    const mins = Math.floor(ms / 1000 / 60);
    return mins <= 0 ? 'Arr' : `${mins}m`;
};
const sortServices = (a, b)=>{
    const a0 = a.toString()[0];
    const b0 = b.toString()[0];
    if (isNaN(a0) && !isNaN(b0)) return 1;
    if (!isNaN(a0) && isNaN(b0)) return -1;
    const result = a0 - b0;
    if (result !== 0) return result;
    return parseInt(a, 10) - parseInt(b, 10);
};
const sortServicesPinned = (pinnedServices)=>(a, b)=>{
        const pinA = pinnedServices.includes(a.no);
        const pinB = pinnedServices.includes(b.no);
        if (pinA && !pinB) return -1;
        else if (pinB && !pinA) return 1;
        else return sortServices(a.no, b.no);
    };

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"kNdlE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _lscache = require("lscache");
var _lscacheDefault = parcelHelpers.interopDefault(_lscache);
exports.default = (url, timeout)=>{
    const data = (0, _lscacheDefault.default).get(url);
    if (data) return Promise.resolve(data);
    else return fetch(url).then((r)=>r.json()).then((r)=>{
        (0, _lscacheDefault.default).set(url, r, timeout);
        return r;
    });
};

},{"lscache":"1Js1m","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"1Js1m":[function(require,module,exports,__globalThis) {
/**
 * lscache library
 * Copyright (c) 2011, Pamela Fox
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* jshint undef:true, browser:true, node:true */ /* global define */ (function(root, factory) {
    if (typeof define === 'function' && define.amd) // AMD. Register as an anonymous module.
    define([], factory);
    else if (module.exports) // CommonJS/Node module
    module.exports = factory();
    else // Browser globals
    root.lscache = factory();
})(this, function() {
    // Prefix for all lscache keys
    var CACHE_PREFIX = 'lscache-';
    // Suffix for the key name on the expiration items in localStorage
    var CACHE_SUFFIX = '-cacheexpiration';
    // expiration date radix (set to Base-36 for most space savings)
    var EXPIRY_RADIX = 10;
    // time resolution in milliseconds
    var expiryMilliseconds = 60000;
    // ECMAScript max Date (epoch + 1e8 days)
    var maxDate = calculateMaxDate(expiryMilliseconds);
    var cachedStorage;
    var cachedJSON;
    var cacheBucket = '';
    var warnings = false;
    // Determines if localStorage is supported in the browser;
    // result is cached for better performance instead of being run each time.
    // Feature detection is based on how Modernizr does it;
    // it's not straightforward due to FF4 issues.
    // It's not run at parse-time as it takes 200ms in Android.
    function supportsStorage() {
        var key = '__lscachetest__';
        var value = key;
        if (cachedStorage !== undefined) return cachedStorage;
        // some browsers will throw an error if you try to access local storage (e.g. brave browser)
        // hence check is inside a try/catch
        try {
            if (!localStorage) return false;
        } catch (ex) {
            return false;
        }
        try {
            setItem(key, value);
            removeItem(key);
            cachedStorage = true;
        } catch (e) {
            // If we hit the limit, and we don't have an empty localStorage then it means we have support
            if (isOutOfSpace(e) && localStorage.length) cachedStorage = true; // just maxed it out and even the set test failed.
            else cachedStorage = false;
        }
        return cachedStorage;
    }
    // Check to set if the error is us dealing with being out of space
    function isOutOfSpace(e) {
        return e && (e.name === 'QUOTA_EXCEEDED_ERR' || e.name === 'NS_ERROR_DOM_QUOTA_REACHED' || e.name === 'QuotaExceededError');
    }
    // Determines if native JSON (de-)serialization is supported in the browser.
    function supportsJSON() {
        /*jshint eqnull:true */ if (cachedJSON === undefined) cachedJSON = window.JSON != null;
        return cachedJSON;
    }
    /**
   * Returns a string where all RegExp special characters are escaped with a \.
   * @param {String} text
   * @return {string}
   */ function escapeRegExpSpecialCharacters(text) {
        return text.replace(/[[\]{}()*+?.\\^$|]/g, '\\$&');
    }
    /**
   * Returns the full string for the localStorage expiration item.
   * @param {String} key
   * @return {string}
   */ function expirationKey(key) {
        return key + CACHE_SUFFIX;
    }
    /**
   * Returns the number of minutes since the epoch.
   * @return {number}
   */ function currentTime() {
        return Math.floor(new Date().getTime() / expiryMilliseconds);
    }
    /**
   * Wrapper functions for localStorage methods
   */ function getItem(key) {
        return localStorage.getItem(CACHE_PREFIX + cacheBucket + key);
    }
    function setItem(key, value) {
        // Fix for iPad issue - sometimes throws QUOTA_EXCEEDED_ERR on setItem.
        localStorage.removeItem(CACHE_PREFIX + cacheBucket + key);
        localStorage.setItem(CACHE_PREFIX + cacheBucket + key, value);
    }
    function removeItem(key) {
        localStorage.removeItem(CACHE_PREFIX + cacheBucket + key);
    }
    function eachKey(fn) {
        var prefixRegExp = new RegExp('^' + CACHE_PREFIX + escapeRegExpSpecialCharacters(cacheBucket) + '(.*)');
        // We first identify which keys to process
        var keysToProcess = [];
        var key, i;
        for(i = 0; i < localStorage.length; i++){
            key = localStorage.key(i);
            key = key && key.match(prefixRegExp);
            key = key && key[1];
            if (key && key.indexOf(CACHE_SUFFIX) < 0) keysToProcess.push(key);
        }
        // Then we apply the processing function to each key
        for(i = 0; i < keysToProcess.length; i++)fn(keysToProcess[i], expirationKey(keysToProcess[i]));
    }
    function flushItem(key) {
        var exprKey = expirationKey(key);
        removeItem(key);
        removeItem(exprKey);
    }
    function flushExpiredItem(key) {
        var exprKey = expirationKey(key);
        var expr = getItem(exprKey);
        if (expr) {
            var expirationTime = parseInt(expr, EXPIRY_RADIX);
            // Check if we should actually kick item out of storage
            if (currentTime() >= expirationTime) {
                removeItem(key);
                removeItem(exprKey);
                return true;
            }
        }
    }
    function warn(message, err) {
        if (!warnings) return;
        if (!('console' in window) || typeof window.console.warn !== 'function') return;
        window.console.warn("lscache - " + message);
        if (err) window.console.warn("lscache - The error was: " + err.message);
    }
    function calculateMaxDate(expiryMilliseconds) {
        return Math.floor(8.64e15 / expiryMilliseconds);
    }
    var lscache = {
        /**
     * Stores the value in localStorage. Expires after specified number of minutes.
     * @param {string} key
     * @param {Object|string} value
     * @param {number} time
     * @return {boolean} whether the value was inserted successfully
     */ set: function(key, value, time) {
            if (!supportsStorage()) return false;
            // If we don't get a string value, try to stringify
            // In future, localStorage may properly support storing non-strings
            // and this can be removed.
            if (!supportsJSON()) return false;
            try {
                value = JSON.stringify(value);
            } catch (e) {
                // Sometimes we can't stringify due to circular refs
                // in complex objects, so we won't bother storing then.
                return false;
            }
            try {
                setItem(key, value);
            } catch (e) {
                if (isOutOfSpace(e)) {
                    // If we exceeded the quota, then we will sort
                    // by the expire time, and then remove the N oldest
                    var storedKeys = [];
                    var storedKey;
                    eachKey(function(key, exprKey) {
                        var expiration = getItem(exprKey);
                        if (expiration) expiration = parseInt(expiration, EXPIRY_RADIX);
                        else // TODO: Store date added for non-expiring items for smarter removal
                        expiration = maxDate;
                        storedKeys.push({
                            key: key,
                            size: (getItem(key) || '').length,
                            expiration: expiration
                        });
                    });
                    // Sorts the keys with oldest expiration time last
                    storedKeys.sort(function(a, b) {
                        return b.expiration - a.expiration;
                    });
                    var targetSize = (value || '').length;
                    while(storedKeys.length && targetSize > 0){
                        storedKey = storedKeys.pop();
                        warn("Cache is full, removing item with key '" + storedKey.key + "'");
                        flushItem(storedKey.key);
                        targetSize -= storedKey.size;
                    }
                    try {
                        setItem(key, value);
                    } catch (e) {
                        // value may be larger than total quota
                        warn("Could not add item with key '" + key + "', perhaps it's too big?", e);
                        return false;
                    }
                } else {
                    // If it was some other error, just give up.
                    warn("Could not add item with key '" + key + "'", e);
                    return false;
                }
            }
            // If a time is specified, store expiration info in localStorage
            if (time) setItem(expirationKey(key), (currentTime() + time).toString(EXPIRY_RADIX));
            else // In case they previously set a time, remove that info from localStorage.
            removeItem(expirationKey(key));
            return true;
        },
        /**
     * Retrieves specified value from localStorage, if not expired.
     * @param {string} key
     * @return {string|Object}
     */ get: function(key) {
            if (!supportsStorage()) return null;
            // Return the de-serialized item if not expired
            if (flushExpiredItem(key)) return null;
            // Tries to de-serialize stored value if its an object, and returns the normal value otherwise.
            var value = getItem(key);
            if (!value || !supportsJSON()) return value;
            try {
                // We can't tell if its JSON or a string, so we try to parse
                return JSON.parse(value);
            } catch (e) {
                // If we can't parse, it's probably because it isn't an object
                return value;
            }
        },
        /**
     * Removes a value from localStorage.
     * Equivalent to 'delete' in memcache, but that's a keyword in JS.
     * @param {string} key
     */ remove: function(key) {
            if (!supportsStorage()) return;
            flushItem(key);
        },
        /**
     * Returns whether local storage is supported.
     * Currently exposed for testing purposes.
     * @return {boolean}
     */ supported: function() {
            return supportsStorage();
        },
        /**
     * Flushes all lscache items and expiry markers without affecting rest of localStorage
     */ flush: function() {
            if (!supportsStorage()) return;
            eachKey(function(key) {
                flushItem(key);
            });
        },
        /**
     * Flushes expired lscache items and expiry markers without affecting rest of localStorage
     */ flushExpired: function() {
            if (!supportsStorage()) return;
            eachKey(function(key) {
                flushExpiredItem(key);
            });
        },
        /**
     * Appends CACHE_PREFIX so lscache will partition data in to different buckets.
     * @param {string} bucket
     */ setBucket: function(bucket) {
            cacheBucket = bucket;
        },
        /**
     * Resets the string being appended to CACHE_PREFIX so lscache will use the default storage behavior.
     */ resetBucket: function() {
            cacheBucket = '';
        },
        /**
     * @returns {number} The currently set number of milliseconds each time unit represents in
     *   the set() function's "time" argument.
     */ getExpiryMilliseconds: function() {
            return expiryMilliseconds;
        },
        /**
     * Sets the number of milliseconds each time unit represents in the set() function's
     *   "time" argument.
     * Sample values:
     *  1: each time unit = 1 millisecond
     *  1000: each time unit = 1 second
     *  60000: each time unit = 1 minute (Default value)
     *  360000: each time unit = 1 hour
     * @param {number} milliseconds
     */ setExpiryMilliseconds: function(milliseconds) {
            expiryMilliseconds = milliseconds;
            maxDate = calculateMaxDate(expiryMilliseconds);
        },
        /**
     * Sets whether to display warnings when an item is removed from the cache or not.
     */ enableWarnings: function(enabled) {
            warnings = enabled;
        }
    };
    // Return the module
    return lscache;
});

},{}],"kYMHw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (iconText)=>{
    let iconSize = 512;
    let iconBackgroundColor = '#F01B48';
    let iconPrimaryColor = '#FFFFFF';
    let iconTextFont = `bold ${Math.round(iconSize * 0.2)}px -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Oxygen, Ubuntu, Cantarell, \"Open Sans\", \"Helvetica Neue\", sans-serif`;
    // canvas handles
    let c = document.createElement('canvas');
    c.width = iconSize;
    c.height = iconSize;
    let ctx = c.getContext('2d');
    // whitewash canvas first
    ctx.fillStyle = iconPrimaryColor;
    ctx.fillRect(0, 0, c.width, c.height);
    // draw radii. someday I hope canvas comes up with a fillRoundedRect()
    // 1:6.4 ratio (magic const of 0.15625) from https://stackoverflow.com/questions/2105289/iphone-app-icons-exact-radius
    // inset distance of 120 was eyeballed
    ctx.fillStyle = iconBackgroundColor;
    let iconInsetDistance = 120;
    let arcRadius = Math.round(c.width * 0.15625);
    ctx.beginPath();
    ctx.moveTo(iconInsetDistance - arcRadius, iconInsetDistance);
    ctx.quadraticCurveTo(iconInsetDistance - arcRadius, iconInsetDistance - arcRadius, iconInsetDistance, iconInsetDistance - arcRadius);
    ctx.lineTo(c.width - iconInsetDistance, iconInsetDistance - arcRadius);
    ctx.quadraticCurveTo(c.width - iconInsetDistance + arcRadius, iconInsetDistance - arcRadius, c.width - iconInsetDistance + arcRadius, iconInsetDistance);
    ctx.lineTo(c.width - iconInsetDistance + arcRadius, c.height - iconInsetDistance);
    ctx.quadraticCurveTo(c.width - iconInsetDistance + arcRadius, c.height - iconInsetDistance + arcRadius, c.width - iconInsetDistance, c.height - iconInsetDistance + arcRadius);
    ctx.lineTo(iconInsetDistance, c.height - iconInsetDistance + arcRadius);
    ctx.quadraticCurveTo(iconInsetDistance - arcRadius, c.height - iconInsetDistance + arcRadius, iconInsetDistance - arcRadius, c.height - iconInsetDistance);
    ctx.lineTo(iconInsetDistance - arcRadius, iconInsetDistance);
    ctx.fill();
    // draw the icon text
    // bus stop codes are consistently 5-characters wide
    ctx.font = iconTextFont;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillStyle = iconPrimaryColor;
    ctx.fillText(iconText, c.width / 2, c.height / 2);
    // replace existing apple-touch-icon
    document.querySelector('[rel="apple-touch-icon"]').setAttribute('href', c.toDataURL());
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"7XWv2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ArrivalTimeText);
var _preact = require("preact");
var _reactI18Next = require("react-i18next");
function ArrivalTimeText({ ms }) {
    const { t } = (0, _reactI18Next.useTranslation)();
    if (ms === null) return;
    const mins = Math.floor(ms / 1000 / 60);
    return mins <= 0 ? t('glossary.arriving') : t('glossary.arrivingMinutes', {
        count: mins
    });
}

},{"preact":"fvkQC","react-i18next":"3s9bS","@parcel/transformer-js/src/esmodule-helpers.js":"ftQX7"}],"l7Ehb":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("eLRmK");

},{}],"jzyZP":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("jWxbY");

},{}],"knC2F":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("aNzh1");

},{}],"4C2c8":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("iEMtA");

},{}],"m2QM4":[function(require,module,exports,__globalThis) {
module.exports = module.bundle.resolve("23O3W");

},{}]},["2Iv0m","irHKn"], "irHKn", "parcelRequireda9d", {}, "./", "/")

//# sourceMappingURL=bus-arrival.e91507f6.js.map
